<template>
  <div class="share">
     <div  class="zhanwei"  >
         <img src="../../assets/noprogram@2x.png" alt="">
      </div>
    <!-- <video src="http://1258023332.vod2.myqcloud.com/eb4cfd27vodtranscq1258023332/04b971055285890793924897683/v.f20.mp4"></video> -->
  </div>
</template>

<script>
export default {
  name: 'share',
  props: {
  
   },
   data(){
     return {
　　　
　 　}
   },
  

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.zhanwei{
  width:100%;
  margin:auto;
  text-align:center;
}
</style>
